import Dropdown from 'react-bootstrap/Dropdown';
import { DropField } from '../../../elements/general';
import { useEffect, useRef, useState } from 'react';
import useRequestLocation from '../../../../hooks/useRequestLocation';
import { useTranslation } from 'react-i18next';
import { getFormattedPeriod, isSameMaster } from './utils';

const MasterSelectFilter = ({
  endData,
  startData,
  selectedMaster,
  setSelectedMaster,
  haircutType,
  service,
  handleSetMastersData,
  selfPermission,
  defaultSelfMaster,
  setDefaultSelfMaster,
  syncAppliedMaster
}) => {
  const [masterList, setMasterList] = useState([])
  const { t } = useTranslation();
  const { getMasters } = useRequestLocation();
  const latestValuesRef = useRef({
    getMasters,
    handleSetMastersData,
    defaultSelfMaster,
    selectedMaster,
    setDefaultSelfMaster,
    setSelectedMaster,
    syncAppliedMaster
  });

  latestValuesRef.current = {
    getMasters,
    handleSetMastersData,
    defaultSelfMaster,
    selectedMaster,
    setDefaultSelfMaster,
    setSelectedMaster,
    syncAppliedMaster
  };

  useEffect(() => {
    const {
      getMasters: requestMasters,
      handleSetMastersData: setMastersDataState,
      defaultSelfMaster: currentDefaultSelfMaster,
      selectedMaster: currentSelectedMaster,
      setDefaultSelfMaster: updateDefaultSelfMaster,
      setSelectedMaster: updateSelectedMaster,
      syncAppliedMaster: updateAppliedMaster
    } = latestValuesRef.current;
    const { periodToStart, periodToEnd } = getFormattedPeriod(startData, endData);

    requestMasters(periodToEnd, periodToStart, haircutType, service).then((countMasters) => {
      setMastersDataState(!countMasters.length);
      const mappedMasters = countMasters.map((el) => {
        const name = el.name.buckets[0]?.key;
        return {
          surname: el.key,
          name,
          id: `${el.key}_${name}`
        };
      });

      setMasterList(mappedMasters);

      if (!selfPermission) {
        return;
      }

      if (mappedMasters.length === 1) {
        const [singleMaster] = mappedMasters;

        if (!isSameMaster(currentDefaultSelfMaster, singleMaster)) {
          updateDefaultSelfMaster(singleMaster);
        }

        if (!isSameMaster(currentSelectedMaster, singleMaster)) {
          updateSelectedMaster(singleMaster);
          updateAppliedMaster(singleMaster);
        }

        return;
      }

      if (mappedMasters.length === 0 && currentDefaultSelfMaster) {
        if (!isSameMaster(currentSelectedMaster, currentDefaultSelfMaster)) {
          updateSelectedMaster(currentDefaultSelfMaster);
          updateAppliedMaster(currentDefaultSelfMaster);
        }
      }
    });
  }, [startData, endData, haircutType, service, selfPermission])

  const isMasterSelectDisabled = selfPermission && !!defaultSelfMaster;

  const handleMasterSelect = (item) => {
    if (isMasterSelectDisabled) return;
    setSelectedMaster(item);
  };

  return (
    <DropField className={`custom-dropdown py-2 rounder-4px border ${isMasterSelectDisabled ? 'mepos-select-disabled' : ''}`}>
      <Dropdown.Toggle className="form-select" disabled={isMasterSelectDisabled}>
          <span className="col-11 text-start text-truncate pe-2">
            {selectedMaster.id ?
              `${selectedMaster.name} ${selectedMaster.surname}`
              :
              t('filters.allMasters')
            }
          </span>
      </Dropdown.Toggle>

      <Dropdown.Menu className='custom-dropdown-menu'>
        <Dropdown.Item onClick={() => handleMasterSelect('all')}
                       className={selectedMaster === 'all' ? 'active' : ''}>
          {t('filters.allMasters')}
        </Dropdown.Item>
        {masterList.map((item) => (
          <Dropdown.Item key={item.id} onClick={() => handleMasterSelect(item)}
                         className={isSameMaster(item, selectedMaster) ? 'active' : ''}>
            {item.name} {item.surname}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </DropField>
  );
};

export default MasterSelectFilter;
